import React, { useEffect, useState } from 'react';
import { Card } from 'primereact/card';
import { getRecentCheckInHistory } from '../../redux/actions/CheckIn/CheckIn';
import { useDispatch, useSelector } from 'react-redux';
import { getImageURL } from '../../utils/imageUrl';
import { CustomInput } from '../../shared/Input/AllInputs';
import PrimaryButton, { CustomButton } from '../../shared/Button/CustomButton';
import { CustomFilterCard } from '../../shared/Cards/CustomCard';
import useFilters from '../../hooks/useFilters';
import FilterComponent from '../../components/FilterComponent';
import maleAvatarImage from '../../../src/assets/images/male-avatar.png';
import femaleAvatarImage from '../../../src/assets/images/female-avatar.png';
import CustomAvatar from '../../shared/Avatar/Avatar';
import { getDateandTime } from '../../utils/commonFunctions';
import { useHistory } from 'react-router-dom';
import { Sidebar } from 'primereact/sidebar';

const RecentCheckIn = ({ checkInVisiblity, setCheckInVisibility }) => {
    const dispatch = useDispatch();
    const statusColors = {
        active: 'green-500',
        canceled: 'red-500',
        pending: 'yellow-500',
    };
    const [data, setData] = useState({
        filterType: 'AND',
    });
    useEffect(() => {
        dispatch(getRecentCheckInHistory());
    }, [dispatch]);
    const getCheckInHistory = useSelector((state) => state.checkin.getCheckInHistory);
    const { tableData, onFilterOpen, onFilterClose, onApplyFilters, filters, isFilterVisible } = useFilters(getCheckInHistory);
    const statusBackgrounds = {
        active: 'bg-green-100',
        canceled: 'bg-red-100',
    };
    const CheckInCard = ({ checkIn }) => {
        const borderColor = statusColors?.active || 'gray-500';
        const backgroundColor = statusBackgrounds?.active || 'bg-gray-100';

        const getImage = () => {
            if (!checkIn.image) {
                return checkIn.gender === 'MALE' ? maleAvatarImage : femaleAvatarImage;
            }
            return getImageURL(checkIn.image) || null;
        };

        const history = useHistory();

        const onSelect = () => {
            setCheckInVisibility(false);
            history.replace(`/member/${checkIn?.memberId}/dashboard`);
        };

        return (
            <Card
                className={`recent-card border-2 border-${borderColor} ${backgroundColor} border-round-3xl shadow-2 flex-no-shrink`}
                style={{ width: '200px', textAlign: 'center' }}
            >
                <div className="flex flex-column align-items-center gap-2">
                    <CustomAvatar image={getImage()} shape="circle" size="xlarge" style={{ backgroundColor: '#c5c9d5', width: '79px', height: '73px' }} />

                    <div>
                        <h4 className="m-0 cursor-pointer" onClick={onSelect}>
                            {checkIn.member}
                        </h4>
                        <p className="text-sm m-0 text-gray-500">{checkIn.reason || checkIn?.membershipPlan?.name}</p>
                        <p className="text-sm m-0 text-blue-600">{getDateandTime(checkIn.createdAt)}</p>

                        {checkIn.status === 'canceled' && (
                            <div className="flex align-items-center mt-2 text-red-500">
                                <i className="pi pi-exclamation-triangle mr-2"></i>
                                <span>Membership Canceled</span>
                            </div>
                        )}
                    </div>
                </div>
            </Card>
        );
    };

    const CheckInCardSmall = ({ checkIn }) => {
        const borderColor = statusColors?.active || 'gray-500';
        const backgroundColor = statusBackgrounds?.active || 'bg-gray-100';

        const getImage = () => {
            if (!checkIn.image) {
                return checkIn.gender === 'MALE' ? maleAvatarImage : femaleAvatarImage;
            }
            return getImageURL(checkIn.image) || null;
        };

        const history = useHistory();

        const onSelect = () => {
            setCheckInVisibility(false);
            history.replace(`/member/${checkIn?.memberId}/dashboard`);
        };

        return (
            <div
                className={`border-2 border-${borderColor} ${backgroundColor} border-round-3xl shadow-2 flex-no-shrink p-1 my-auto`}
                style={{ width: '200px', textAlign: 'center' }}
            >
                <div className="flex justify-content-center align-items-center gap-2 my-auto h-full">
                    <CustomAvatar image={getImage()} shape="circle" className="my-auto" style={{ backgroundColor: '#c5c9d5', width: '40px', height: '40px' }} />

                    <div className="flex flex-column w-10 align-items-center gap-2 m-auto">
                        <div>
                            <div className="m-0 text-sm cursor-pointer" onClick={onSelect}>
                                {checkIn.member}
                            </div>
                            <p className="text-sm m-0 text-gray-500">{checkIn.reason || checkIn?.membershipPlan?.name}</p>
                            <div className="text-xs m-0 text-blue-600">{getDateandTime(checkIn.createdAt)}</div>
                        </div>
                    </div>
                </div>
            </div>
        );
    };
    const history = useHistory();
    const handleChange = ({ name, value }) => {
        setData((prev) => ({ ...prev, [name]: value }));
    };
    if (!getCheckInHistory?.length) return null;

    const sidebarHeader = (
        <div className="w-full mx-3 flex justify-content-between">
            <h3 className="my-auto">Recent Check-Ins</h3>
            <div className="flex gap-2">
                <PrimaryButton
                    label="More"
                    onClick={() => {
                        setCheckInVisibility(false);
                        history.push('/more/attendance/check-in-history');
                    }}
                />
                <PrimaryButton label="Filter" icon="pi pi-filter" onClick={onFilterOpen} />
            </div>
        </div>
    );

    return (
        <>
            <div className="checkin-bottombar">
                <div className="flex justify-content-between gap-3">
                    <div className="flex gap-3 overflow-x-auto" style={{ scrollbarWidth: 'none' }}>
                        {tableData?.slice(0, 10).map((checkIn, index) => (
                            <CheckInCardSmall key={index} checkIn={checkIn} />
                        ))}
                    </div>

                    <div className="px-1">
                        <CustomButton icon="pi pi-angle-double-up" onClick={() => setCheckInVisibility(true)} rounded severity="info" />
                    </div>
                </div>
            </div>

            <Sidebar style={{ height: '285px' }} visible={checkInVisiblity} icons={sidebarHeader} position="bottom" onHide={() => setCheckInVisibility(false)}>
                <div className="p-2">
                    <div className="flex gap-3 overflow-x-auto">
                        {tableData?.slice(0, 10).map((checkIn, index) => (
                            <CheckInCard key={index} checkIn={checkIn} />
                        ))}
                    </div>
                    <FilterComponent
                        value={filters}
                        onApply={onApplyFilters}
                        visible={isFilterVisible}
                        onHide={onFilterClose}
                        data={data}
                        handleChange={handleChange}
                        setData={setData}
                    >
                        <div>
                            <CustomInput name="member" data={data} onChange={handleChange} col={12} />
                            {/* <CustomCalenderInput name="from" data={data} onChange={handleChange} col={12} maxDate={data.to} />
                        <CustomCalenderInput name="to" data={data} onChange={handleChange} col={12} minDate={data.from} /> */}
                        </div>
                    </FilterComponent>
                </div>
            </Sidebar>
        </>
    );
};

export default RecentCheckIn;
